import "../../styles/clientPortalUploads.css";

const EMPTY_LINK = { label: "", url: "" };

function ExternalLinksEditor({ links = [], onChange, disabled = false }) {
  const items = links.length ? links : [EMPTY_LINK];

  const updateItem = (index, field, value) => {
    const next = items.map((item, i) => (i === index ? { ...item, [field]: value } : item));
    onChange(next.filter((item) => item.label?.trim() || item.url?.trim()));
  };

  const addLink = () => {
    onChange([...items, { ...EMPTY_LINK }]);
  };

  const removeLink = (index) => {
    const next = items.filter((_, i) => i !== index);
    onChange(next.length ? next : []);
  };

  return (
    <div className="cp-external-links">
      <div className="cp-external-links-header">
        <div>
          <strong>Related links</strong>
          <p className="muted cp-upload-hint">
            Add HOA portals, community websites, documents, and other helpful URLs.
          </p>
        </div>
        <button type="button" className="btn btn-secondary" disabled={disabled} onClick={addLink}>
          + Add link
        </button>
      </div>

      <div className="cp-external-links-list">
        {items.map((item, index) => (
          <div key={`link-${index}`} className="cp-external-link-row">
            <input
              type="text"
              className="cp-upload-url-input"
              placeholder="Label (e.g. HOA portal)"
              value={item.label || ""}
              disabled={disabled}
              onChange={(e) => updateItem(index, "label", e.target.value)}
            />
            <input
              type="url"
              className="cp-upload-url-input"
              placeholder="https://example.com"
              value={item.url || ""}
              disabled={disabled}
              onChange={(e) => updateItem(index, "url", e.target.value)}
            />
            <button
              type="button"
              className="cv-button-link cp-settings-danger-link"
              disabled={disabled}
              onClick={() => removeLink(index)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ExternalLinksEditor;
